//====================================================
//  Initialization Slider
//====================================================
function fn_components_slider(){
    fn_main_slider();
}


function fn_main_slider(){
    if ($('.js-main-slider').length) {
        var $status = $('.paging-info ul');
        var slideNumber;
        
        $('.js-main-slider').on('init reInit afterChange', function(event, slick, currentSlide, nextSlide){
            slideNumber = (currentSlide ? currentSlide : 0);
            var content = [];
            var contentText = ['Academics', 'Apply', 'Anniversary']
            for(j = 0; j < slick.slideCount; j++){
              if (j == slideNumber){
                content.push('<li class="active"> ' + contentText[j] + '</li>');
              } else {
                content.push('<li>' + contentText[j] + '</li>');
              }
            }
            $status.html(content);
        });

        $(document).on('click','.paging-info li', function(){
          var slideNo = $(this).index();
          $('.js-main-slider').slick('slickGoTo', slideNo);
        });


        $('.js-main-slider').slick({
            infinite: true,
            dots: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 3000,
            cssEase: 'linear',
            speed: 500,
            nextArrow: '<span class="slick-arrows slick-next"><i class="icon icon-chevron-thin-right"></i></span>',
            prevArrow: '<span class="slick-arrows slick-prev"><i class="icon icon-chevron-thin-left"></i></span>',
            //fade: true,
            variableWidth: false,
            mobileFirst: true
        });

    }

}

